import React, { useState, useRef, useEffect } from 'react';
import { MathJaxContext } from 'better-react-mathjax';
import ChatBotHeader from './chatbotHeader';
import PredefinedQuestions from './questions';
import ChatMessages from './chatMessages';
import ChatToolbar from './chatToolBar';

const ChatBotPopup = ({
    onClose,
    messages,
    predefinedQuestions,
    input,
    setInput,
    handleSend,
    headerTitle,
    headerSubtitle,
    nisabValue,
    isTyping,
    liveBotResponse,
    isShowButton,
    paymentProceed,
    updateMessage,
    isSending,
    showEmojiPicker,
    setShowEmojiPicker,
    fileUpload,
    isRemoveFile,
    setAttachmentError,
    attachmentError,
    showFile,
    resetFileObject,
    isVoiceInput,
    isListening,
    mediaRecorder,
    inputRef,
    handleStartListening,
    handleStopListening,
    handleDiscard,
    onClosePopup,
    onZakatData,
    recordingStatus,
    isLoading,
}) => {
    const chatContainerRef = useRef(null);

    useEffect(() => {
        const container = chatContainerRef.current;
        if (!container) return;
    
        const observer = new MutationObserver(() => {
                container.scrollTo({
                top: container.scrollHeight,
                    behavior: 'smooth',
            });
        });
    
        observer.observe(container, {
            childList: true,
            subtree: true,
            characterData: true,
        });
    
        return () => observer.disconnect();
    }, [messages.current]);

    const config = {
        loader: { load: ['[tex]/require'] },
        tex: {
          inlineMath: [['\\(', '\\)']],
          displayMath: [['\\[', '\\]']],
        },
    };

    
    return (
        <MathJaxContext version={3} config={config}>
            <div className={`chatBot-container ${showFile ? "file-added" : ""}`}>
                {/* <ChatBotHeader
                    headerTitle={headerTitle}
                    headerSubtitle={headerSubtitle}
                    nisabValue={nisabValue}
                /> */}
                <PredefinedQuestions
                    predefinedQuestions={predefinedQuestions}
                    setInput={setInput}
                    onSendMessage={handleSend}
                    isSending={isSending}
                />
                <ChatMessages
                    messages={messages}
                    isBotTyping={isTyping}
                    isShowButton={isShowButton}
                    paymentProceed={paymentProceed}
                    chatContainerRef={chatContainerRef}
                />
                <div className="chatBot-footer">
                    <ChatToolbar
                        input={input}
                        setInput={setInput}
                        onSendMessage={handleSend}
                        isSending={isSending}
                        isListening={isListening}
                        mediaRecorder={mediaRecorder}
                        inputRef={inputRef}
                        isLoading={isLoading}
                        handleStartListening={handleStartListening}
                        handleStopListening={handleStopListening}
                        handleDiscard={handleDiscard}
                        showEmojiPicker={showEmojiPicker}
                        setShowEmojiPicker={setShowEmojiPicker}
                        fileUpload={fileUpload}
                        isRemoveFile={isRemoveFile}
                        setAttachmentError={setAttachmentError}
                        attachmentError={attachmentError}
                        showFile={showFile}
                        resetFileObject={resetFileObject}
                        updateMessage={updateMessage}
                        onClosePopup={onClosePopup}
                        showVoiceAssistant={true}  // Show Voice Assistant
                        showDictate={true}// shiw Dictate option
                        onZakatData={onZakatData}
                        recordingStatus={recordingStatus}
                        isTyping={isTyping}
                    />
                </div>
            </div>
        </MathJaxContext>
    );
};

export default ChatBotPopup;